import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "@fontsource-variable/inter";
import "@fontsource-variable/playfair-display";
import "@fontsource/tinos/400.css";
import "@fontsource/tinos/400-italic.css";
import "@fontsource/tinos/700.css";
import "@fontsource/tinos/700-italic.css";
import App from "./App.tsx";
import "./index.css";
import { initGlobalErrorCapture } from "@/lib/debugLogger";

// Initialize global error capture for debug logging
initGlobalErrorCapture();

// MaintenanceRedirect inside App handles reactive maintenance checks
// No root-level gate needed - redirect happens at route level
createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
